import React from "react";
import Chart from "react-apexcharts";
import { makeStyles, useTheme } from "@material-ui/core";
import clsx from "clsx";
import { createBasicChartOptions, } from "./model";
const createOptions = (theme, opts) => {
    var _a;
    const [basicOptions, defaultFont] = createBasicChartOptions(theme, opts);
    return Object.assign(Object.assign({}, basicOptions), { labels: opts.labels, dataLabels: {
            formatter: (_a = opts.formatters) === null || _a === void 0 ? void 0 : _a.dataLabel,
            enabled: !opts.hideDataLabels,
            style: Object.assign(Object.assign({}, defaultFont), { colors: [theme.palette.text.onColor] }),
        } });
};
export default ({ series, className, width = "100%", height = "auto", hideDataLabels, hideTooltip, hideLegend, showMarkers = false, animate = false, type = "donut", labels = [], formatters = {
    dataLabel: (val) => `${Math.round(+val)}%`,
}, noDataText = "Нет данных", }) => {
    const theme = useTheme();
    const classes = useStyles();
    return (React.createElement(Chart, { width: width, height: height, series: series, type: type, className: clsx(classes.root, className), options: createOptions(theme, {
            hideLegend,
            hideTooltip,
            hideDataLabels,
            animate,
            showMarkers,
            noDataText,
            formatters,
            labels,
        }) }));
};
const useStyles = makeStyles((theme) => ({
    root: {
        "& .apexcharts-tooltip": {
            overflow: "hidden",
            border: "0.5px solid #EBEDF0",
            boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.04), 0px 4px 4px rgba(0, 0, 0, 0.08)",
            borderRadius: 4,
            margin: "8px 0",
            "& .apexcharts-tooltip-series-group": {
                backgroundColor: `${theme.palette.text.onColor} !important`,
            },
            "& .apexcharts-tooltip-text": Object.assign(Object.assign({}, theme.typography.h5), { color: theme.palette.text.secondary }),
        },
    },
}));
//# sourceMappingURL=FTLNonAxisChart.js.map